import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
};

const creditNotesSlice = createSlice({
  name: 'creditNotes',
  initialState,
  reducers: {
    cancelCreditNoteRequest(state) {
      state.loading = true;
      state.error = null;
    },
    cancelCreditNoteSuccess(state, action) {
      state.loading = false;
      state.error = null;
    },
    cancelCreditNoteFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    transmitCNToPeppolRequest(state) {
      state.loading = true;
      state.error = null;
    },
    transmitCNToPeppolSuccess(state) {
      state.loading = false;
    },
    transmitCNToPeppolFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  cancelCreditNoteRequest,
  cancelCreditNoteSuccess,
  cancelCreditNoteFailure,
  transmitCNToPeppolRequest,
  transmitCNToPeppolSuccess,
  transmitCNToPeppolFailure,
} = creditNotesSlice.actions;

export default creditNotesSlice.reducer;
